import React from "react";
import { FaRedditAlien } from "react-icons/fa";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(FaRedditAlien).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const RedditIcon = (props) => {
  return <StyledIcon {...props} />;
};

RedditIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default RedditIcon;
